import { HTTP_STATUS } from '../response';

export interface ChangeEmailAndPasswordRequest {
	password: string;
	email: string;
}

export enum PortalErrors {
	EmailConflict = 'EmailConflict',
	EmailInvalidFormat = 'EmailInvalidFormat',
	EmailBlacklisted = 'EmailBlacklisted'
}

export interface ChangeEmailAndPasswordSuccessResponse {
	status: HTTP_STATUS;
	redirectUrl: string;
	playerId: number;
}

export interface ChangeEmailAndPasswordErrorResponse {
	status: HTTP_STATUS;
	error?: PortalErrors;
}

export type ChangeEmailAndPasswordResponse = ChangeEmailAndPasswordSuccessResponse | ChangeEmailAndPasswordErrorResponse;

export type ChangeEmailAndPasswordAction = (
	request: ChangeEmailAndPasswordRequest,
) => Promise<ChangeEmailAndPasswordResponse>;
